
/**
 * 获取当前设备系统平台
 */
export function judgeClient() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
  if (isAndroid) {
    return 'Android';
  } else if (isIOS) {
    return 'IOS';
  } else {
    return 'PC';
  }
}

/**
 * 获取当前手机端还是PC端
 */
export function isMobiles() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag ? true : false
}

/**
 * 
 * @returns 获取当前路由后参数
 */
export function GetRequest() {
  if (!location.href.includes('?')) return
  let url = location.href.split("?")[1].split("&"); //获取url中"?"符后的字串
  // console.log(url);
  let query = {};
  url.forEach(item => {
    query[item.split("=")[0]] = decodeURIComponent(item.split("=")[1]);  //转码
  });
  return query;
}